module.exports = __webpack_public_path__ + "static/media/ar.53647ae9.svg";